import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  AMOUNT_INPUT_CONFIG,
  AmountInputConfig,
} from '@core/config/number-precision.config';
import { formatNumberDisplay } from '@core/utils/number-format.util';

/**
 * Formats a number or string value with thousand separators and decimal precision.
 *
 * @example
 * ```html
 * <p>{{ balance | nttAmount }}</p>
 * <p>{{ '1234567.89' | nttAmount }}</p>
 * <p>{{ amount | nttAmount }}</p>
 * ```
 *
 * The pipe uses the global AMOUNT_INPUT_CONFIG to format numbers.
 * All values are treated as strings internally to avoid JavaScript number precision issues.
 */
@Pipe({
  name: 'nttAmount',
  pure: true,
})
export class AmountPipe implements PipeTransform {
  private readonly _config = inject(AMOUNT_INPUT_CONFIG);

  transform(
    value: string | number | null | undefined,
    config?: Partial<AmountInputConfig>,
  ): string {
    const finalConfig = config ? { ...this._config, ...config } : this._config;

    return formatNumberDisplay(value, finalConfig);
  }
}
